import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i1.10
import React from 'react';
import IconWrap from '../IconWrap';
const Tier = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.91 7.492l-1.76 9.687a1 1 0 01-.985.821H2.835a1 1 0 01-.984-.821L.089 7.492A.417.417 0 01.5 7h.122a1 1 0 01.661.25l4.401 3.877 2.358-7.911a1 1 0 011.916 0l2.358 7.911 4.4-3.877a1 1 0 01.662-.25h.122a.417.417 0 01.41.492z",
        transform: "translate(3 2)"
    })));
};
Tier.displayName = 'Tier';
export default Tier;
